/**
 * Self-serve onboarding route literals (part 4 of the self-serve seam).
 *
 * Pure path constants shared across the web self-serve surface so every caller
 * imports ONE definition of each route instead of re-declaring the string.
 *
 * @since 1.0.0
 */

/** Clerk sign-up entry point for self-serve onboarding. @since 1.0.0 */
export const SIGN_UP_PATH = "/clawinstall/sign-up";

/** First step of the self-serve onboarding flow. @since 1.0.0 */
export const SELF_SERVE_BEGIN_PATH = "/clawinstall/onboarding/begin";

/** Flag appended to the adopt one-liner to opt into remote support. @since 1.0.0 */
export const REMOTE_SUPPORT_FLAG = "--enable-remote-support";
